import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { AppActionCreators } from "../../store/actions/app";
import "react-toastify/dist/ReactToastify.css";

const ToastNotification = () => {
  const { tone, message } = useSelector((state) => state?.app?.notification);
  const dispatch = useDispatch();

  const toastConfigs = {
    info: {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    },
    warning: {
      position: "top-center",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    },
    error: {
      position: "bottom-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    },
  };

  useEffect(() => {
    if (tone && message) {
      if (tone === "info") toast.info(message, toastConfigs.info);
      if (tone === "warning") toast.warning(message, toastConfigs.warning);
      if (tone === "error") toast.error(message, toastConfigs.error);

      dispatch(AppActionCreators.setNotification(null, null));
    }
  }, [tone, message, dispatch]);

  return <ToastContainer />;
};

export default ToastNotification;
